import { Card, Col, Row, Typography, Space, Button } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import ListPanel from "../../../../../molecules/ListPanel";
import { useSelector } from "react-redux";
import { dateByformat } from "../../../../../../utils/dateHelper";
import { Popup } from "../../../../../atoms/Popup";
import EditTenant from "../EditTenant";
import { getLeaseTypesForTenant } from "../../../../../../utils/helper";
import { BankDetails } from "./BankDetails";
import { useGetOrganization } from "../../../../../../api/v1";

const { Title, Text } = Typography;

export default (props) => {
  const { organization } = useGetOrganization();

  const tenantData = useSelector((state: any) => state.tenantsSummary.tenantData);
  const [info, setInfo] = useState([]);
  const [docs, setDocs] = useState([]);
  const [editType, setEditType] = useState(null);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const userDetail = tenantData?.userDetail;
  const userDocDetail = tenantData?.userDocumentDetail;
  const leaseDetails = tenantData?.leaseDetail?.length > 0 ? tenantData?.leaseDetail : [];
  const documentDetail = leaseDetails?.tenantDetails;
  let userKycInfo = tenantData?.userDocumentDetail?.kycData;

  useEffect(() => {
    setInfo([
      {
        key: "Full Name",
        value: userDetail?.name ?? "N/A", // && !tenantData?.last_name
      },
      {
        key: "Arabic Name",
        value: userDocDetail?.arabicName ?? "N/A",
      },
      {
        key: "Phone Number",
        value: userDetail?.mobile || "N/A",
      },
      {
        key: "Email",
        value: userDetail?.email || "N/A",
      },
      {
        key: "Address",
        value: userDocDetail?.address || documentDetail?.address || "N/A",
      },
      {
        key: "City",
        value: userDocDetail?.emirates || documentDetail?.emirates || "N/A",
      },
      {
        key: "Country",
        value: documentDetail?.country || userDocDetail?.country || "N/A",
      },
      {
        key: "Nationality",
        value: userDocDetail?.nationality || documentDetail?.nationality || "N/A",
      },
      {
        key: "Emirates",
        value: userDocDetail?.emirates || documentDetail?.emirates || "N/A",
      },
    ]);

    setDocs([
      {
        key: "Passport Number",
        value: documentDetail?.passport || userDocDetail?.passport || "N/A",
      },
      {
        key: "Passport Expiry Date",
        value:
          documentDetail?.passportExpiry || userDocDetail?.passportExpiry
            ? dateByformat(documentDetail?.passportExpiry || userDocDetail?.passportExpiry, "DD-MM-YYYY")
            : "N/A",
      },
      {
        key: "Emirates ID Number",
        value: documentDetail?.emiratesID || userDocDetail?.emiratesId || "N/A",
      },
      {
        key: "Emirates ID Expiry Date",
        value:
          documentDetail?.emirateIdExpiry || userDocDetail?.emirateIdExpiry
            ? dateByformat(documentDetail?.emirateIdExpiry || userDocDetail?.emirateIdExpiry, "DD-MM-YYYY")
            : "N/A",
      },
      {
        key: "Visa Number",
        value: documentDetail?.uaeVisaNumber || documentDetail?.visaNumber || userDocDetail?.visaNumber || "N/A",
      },
      {
        key: "Visa Expiry Date",
        value:
          documentDetail?.uaeVisaExpiry || documentDetail?.visaExpiry || userDocDetail?.visaExpiry
            ? dateByformat(
                documentDetail?.uaeVisaExpiry || documentDetail?.visaExpiry || userDocDetail?.visaExpiry,
                "DD-MM-YYYY"
              )
            : "N/A",
      },
      {
        key: "Trade License Number",
        value: documentDetail?.tradeLicense || userDocDetail?.tradeLicense || "N/A",
      },
      {
        key: "Trade License Expiry Date",
        value:
          documentDetail?.tradeLicenseExpiry || userDocDetail?.tradeLicenseExpiry
            ? dateByformat(documentDetail?.tradeLicenseExpiry || userDocDetail?.tradeLicenseExpiry, "DD-MM-YYYY")
            : "N/A",
      },
    ]);
  }, [tenantData, userDetail, documentDetail]);

  const onSubmit = () => {
    props.getTenants();
    setVisible(false);
  };

  let kycValues = [];

  let getKycDetail = useMemo(() => {
    return getLeaseTypesForTenant(tenantData);
  }, [JSON.stringify(tenantData)]);

  try {
    getKycDetail?.forEach((element) => {
      kycValues.push({
        key: element.label,
        value: userKycInfo[element?.name] === "selfEmployed" ? "Self Employed" : userKycInfo[element?.name],
      });
    });
  } catch (error) {
    // console.log(error)
  }

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          {editType === 1 ? `Edit Tenant Kyc Details` : `Edit Tenant`}
        </Title>
      ),
      content: (
        <>
          <EditTenant
            onSubmit={onSubmit}
            editType={editType}
            onCancel={() => setVisible(false)}
            info={info}
            trigger={trigger}
            docs={docs}
            tenantDetail={documentDetail}
            userDetail={userDetail}
            isBlockedUser={userDocDetail?.isBlocked === "yes" ? true : false}
            kycDetails={getKycDetail}
            userKycInfo={userKycInfo}
          />
        </>
      ),
      width: 850,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };

  const editDetails = (type, triggerValue) => {
    triggerValue === 1 ? setEditType(1) : setEditType(type);
    setVisible(true);
  };

  return (
    <Card bordered={false} bodyStyle={{ padding: "3em 3.5em" }} className="tenant_detail_cards">
      <Row gutter={[24, 24]}>
        <Col span={18}>
          <Space direction="vertical">
            <Title level={2} className="mb-0">
              {userDetail?.name ?? "N/A"}
            </Title>
          </Space>
        </Col>

        <Col span={24} className="tenent_detail_info">
          <Card bordered={false} bodyStyle={{ padding: "0 32% 0 0" }}>
            <Row gutter={[10, 10]}>
              <Col span={6}>
                <ListPanel data={info} triggerValue={0} title={"Tenant Details"} clickPanel={editDetails} />
              </Col>
              <Col span={6}>
                <ListPanel data={docs} triggerValue={0} title={"Documents"} clickPanel={editDetails} />
              </Col>
              {organization?.enableTenantBankDetails && (
                <Col span={6}>
                  <BankDetails onSubmit={onSubmit} />
                </Col>
              )}
              {getKycDetail?.length > 0 && (
                <Col span={6}>
                  <ListPanel data={kycValues} triggerValue={1} title={"Kyc Details"} clickPanel={editDetails} />
                </Col>
              )}
            </Row>
          </Card>
        </Col>
      </Row>
      <Popup {...popupProps} />
    </Card>
  );
};
